import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { CreateCaseQuery } from "../../global/Types";
import { GetMockCaseQueryList } from "../../mock/case-query/CaseQueryList";
import { GetMockCaseQueryRead } from "../../mock/case-query/CaseQueryRead";

export const useCaseQueryDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);


  const GetMyCaseQueryList = () => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryList());
      } else {
        globalFunctions
          .CallPortalApi("CaseQuery/MyList", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            }
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCaseQueryList = (id: number, incDeleted: boolean) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryList());
      } else {
        globalFunctions
          .CallPortalApi("CaseQuery/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
              IncludeDeleted: incDeleted,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCaseQuery = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryRead());
      } else {
        globalFunctions
          .CallPortalApi("CaseQuery/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const CreateCaseQuery = (caseQuery: CreateCaseQuery) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve("Created");
      } else {
        globalFunctions
          .CallPortalApi("CaseQuery/Create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(caseQuery),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const CloseCaseQuery = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve("Closed");
      } else {
        globalFunctions
          .CallPortalApi("CaseQuery/Close", {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetMyCaseQueryList, GetCaseQueryList, GetCaseQuery, CreateCaseQuery, CloseCaseQuery };
};
